import {
  ActionPlanningScenarioGetScenarioQuery,
  ActionPlanningScenariosAllScenariosQuery,
} from '@predium/client-graphql';

export enum ImpactTrendGraphEnum {
  FINAL_ENERGY = 'final_energy',
  CO_2_EMISSIONS = 'co2_emissions',
  PRIMARY_ENERGY = 'primary_energy',
  COST_BY_RENOVATION_CATEGORY = 'cost_by_renovation_category',
  STRANDING_YEAR_DISTRIBUTION = 'stranding_year_distribution',
  HEATING_ENERGY_SOURCES_DEVELOPMENT = 'heating_energy_sources_development',
  EFFICIENCY_CLASS_DISTRIBUTION = 'efficiency_class_distribution',
  FLOOR_AREA_DEVELOPMENT = 'floor_area_development',
}

export type EnergyOrEmissionsGraphType =
  | ImpactTrendGraphEnum.CO_2_EMISSIONS
  | ImpactTrendGraphEnum.FINAL_ENERGY
  | ImpactTrendGraphEnum.PRIMARY_ENERGY;

/**
 * Which CO₂ target line the decarbonisation chart shows: the CRREM 1.5°C path ('creem') or the
 * org's custom decarbonisation path ('custom-energy'). Mirrors the Analysis page selector (BLU-2955).
 */
export type CustomTargetPathType = 'creem' | 'custom-energy';

/**
 * The action-planning chart header dropdown selection (BLU-2955). Mirrors the Analysis page's CRREM
 * chart: `crrem` and `custom-energy` are decarbonisation views that share the CRREM sub-tabs
 * (CO₂ Path / Energy Path / Misaligned), while the remaining metrics are flat dropdown entries.
 * CO₂ e-intensity, Final energy and Misaligned buildings live inside the CRREM tabs, so they are
 * intentionally absent here.
 */
export type ActionPlanChartView =
  | 'crrem'
  | 'nationalEnergyLaw'
  | 'custom-energy'
  | ImpactTrendGraphEnum.PRIMARY_ENERGY
  | ImpactTrendGraphEnum.COST_BY_RENOVATION_CATEGORY
  | ImpactTrendGraphEnum.HEATING_ENERGY_SOURCES_DEVELOPMENT
  | ImpactTrendGraphEnum.EFFICIENCY_CLASS_DISTRIBUTION
  | ImpactTrendGraphEnum.FLOOR_AREA_DEVELOPMENT;

export type ScenarioOutput = ActionPlanningScenarioGetScenarioQuery['getScenario'];
export type ScenarioRow = ActionPlanningScenariosAllScenariosQuery['getScenarioList']['scenarios'][number];
